import { useEffect, useState } from "react";
import { repositoryMdm } from "../../../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../../../model/MessageResponse";
import { Checkbox, ScrollArea, Table } from "@mantine/core";
import cx from "clsx";
import classes from "../../../../../../Styles/TableScrollArea.module.css";

interface saleChannelModel {
  id: number;
  code: string;
  name: string;
  isCheck: boolean;
  active?: boolean;
  stt?: number;
}

const SaleChannel = ({
  form,
  successCall,
}: {
  form: any;
  successCall: boolean;
}) => {
  const [height, setHeight] = useState(0);
  const [scrolled, setScrolled] = useState(false);
  const [dataSaleChannel, setDataSaleChannnel] = useState<saleChannelModel[]>(
    []
  );

  const getDataSaleChannel = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblDmSaleChanel/get-all"
    );

    if (res && res.success) {
      const dataSCProps = form.getValues()?.listSaleChanel;

      if (dataSCProps?.includes("all")) {
        const result = res.data
          ?.filter((item: any) => item.active)
          ?.map((item: any) => ({
            id: item.id,
            code: item.code,
            name: item.name,
            isCheck: true,
          }));
        setDataSaleChannnel(result);
      } else {
        const result = res.data
          ?.filter((item: any) => item.active)
          ?.map((item: any) => ({
            id: item.id,
            code: item.code,
            name: item.name,
            isCheck: dataSCProps?.includes(String(item.id)) ? true : false,
          }));
        setDataSaleChannnel(result);
      }
    }
  };

  useEffect(() => {
    if (successCall) {
      getDataSaleChannel();
    }
  }, [successCall]);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight - 440);
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  useEffect(() => {
    const dataSet = dataSaleChannel.every((item) => item.isCheck)
      ? "all"
      : dataSaleChannel?.filter((item) => item.isCheck)?.length > 0
      ? dataSaleChannel
          ?.filter((item) => item.isCheck)
          ?.map((item) => item.id)
          ?.join(",")
      : null;

    form.setFieldValue("listSaleChanel", dataSet);
  }, [dataSaleChannel]);

  return (
    <ScrollArea
      h={height}
      onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
    >
      <Table mt={10}>
        <Table.Thead
          className={cx(classes.header, {
            [classes.scrolled]: scrolled,
          })}
        >
          <Table.Tr>
            <Table.Th>
              <Checkbox
                checked={dataSaleChannel.every((item) => item.isCheck)}
                onClick={() => {
                  if (dataSaleChannel.every((item) => item.isCheck)) {
                    const dataSet = dataSaleChannel.map((item) => ({
                      id: item.id,
                      code: item.code,
                      name: item.name,
                      isCheck: false,
                    }));
                    setDataSaleChannnel(dataSet);
                  } else {
                    const dataSet = dataSaleChannel.map((item) => ({
                      id: item.id,
                      code: item.code,
                      name: item.name,
                      isCheck: true,
                    }));
                    setDataSaleChannnel(dataSet);
                  }
                }}
              />
            </Table.Th>
            <Table.Th>Mã kênh bán</Table.Th>
            <Table.Th>Tên kênh bán</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {dataSaleChannel &&
            dataSaleChannel.length > 0 &&
            dataSaleChannel.map((item) => (
              <Table.Tr key={item.id}>
                <Table.Td>
                  <Checkbox
                    checked={item.isCheck}
                    onClick={() => {
                      if (item.isCheck) {
                        const dataSet = dataSaleChannel?.map((i) =>
                          i.id === item.id ? { ...i, isCheck: false } : i
                        );
                        setDataSaleChannnel(dataSet);
                      } else {
                        const dataSet = dataSaleChannel?.map((i) =>
                          i.id === item.id ? { ...i, isCheck: true } : i
                        );
                        setDataSaleChannnel(dataSet);
                      }
                    }}
                  />
                </Table.Td>
                <Table.Td>{item.code}</Table.Td>
                <Table.Td>{item.name}</Table.Td>
              </Table.Tr>
            ))}
        </Table.Tbody>
      </Table>
    </ScrollArea>
  );
};

export default SaleChannel;
